import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import LoadingOverlay from "react-loading-overlay";

import Loader from "../../common/components/Loader";
import { recommendationsTableData, smartChartPropertiesTableData } from "../../../config/tableData";
import actions from "../actions";
import "../../../assets/css/smart-chart.css";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import Portal from "../../common/components/Portal";
import { checkPermission, addToBreadCrumpData, showAlert as showAlertUtil } from "../../../config/utils";
import { permissions } from "../../../config/permissions";
import { resolveDefaultClientFromList } from "../../../utils/dashboardSession";
import PropertiesMain from "./components/PropertyMain";
import LockPasswordModal from "../components/LockPasswordModal";
import ViewPropertyModal from "../components/ViewPropertyModal";
import SourceTemplateModal from "../components/SourceTemplateModal";
import { AppliedFilters } from "../components/Filters";

class Index extends Component {
    constructor(props) {
        super(props);
        const {
            match: {
                params: { section }
            }
        } = this.props;
        this.state = {
            isLoading: true,
            paginationParams: this.props.isSkeletonView
                ? this.props.smartChartReducer.coreReportEntityParams.paginationParams
                : this.props.smartChartReducer.propertyEntityParams.paginationParams,
            showFormModal: false,
            showWildCardFilter: false,
            selectedRowId: this.props.isSkeletonView
                ? this.props.smartChartReducer.coreReportEntityParams.selectedRowId
                : this.props.smartChartReducer.propertyEntityParams.selectedRowId,
            params: this.props.isSkeletonView
                ? this.props.smartChartReducer.coreReportEntityParams.params
                : this.props.smartChartReducer.propertyEntityParams.params,
            tableData: {
                keys: smartChartPropertiesTableData.keys,
                config: this.props.isSkeletonView
                    ? this.props.smartChartReducer.coreReportEntityParams.tableConfig || _.cloneDeep(smartChartPropertiesTableData.config)
                    : this.props.smartChartReducer.propertyEntityParams.tableConfig || _.cloneDeep(smartChartPropertiesTableData.config)
            },
            RecommendationTableData: {
                keys: _.cloneDeep(recommendationsTableData.keys),
                config: this.props.recommendationsReducer.entityParams[section]?.tableConfig || _.cloneDeep(recommendationsTableData.config)
            },
            alertMessage: "",
            wildCardFilterParams: this.props.isSkeletonView
                ? this.props.smartChartReducer.coreReportEntityParams.wildCardFilterParams
                : this.props.smartChartReducer.propertyEntityParams.wildCardFilterParams,
            filterParams: this.props.isSkeletonView
                ? this.props.smartChartReducer.coreReportEntityParams.filterParams
                : this.props.smartChartReducer.propertyEntityParams.filterParams,
            showConfirmModal: false,
            selectedReportTemplate: "",
            selectedSmartChartData: null,
            isRegenerate: false,
            mFilters: this.props.isSkeletonView
                ? { exportby_user_ids: this.props.smartChartReducer.coreReportEntityParams?.exportby_user_ids || [] } || {}
                : { exportby_user_ids: this.props.smartChartReducer.propertyEntityParams?.exportby_user_ids || [] } || {},
            defaultFilterParams: {},
            showLockTemplateModal: false,
            showViewPropertyModal: false,
            showTemplateModal: false,
            parentTemplate: null,
            selectedProperty: null,
            isLockLoading: false,
            sortParams: this.props.isSkeletonView
                ? this.props.smartChartReducer.coreReportEntityParams?.sortParams || { sort_by: "created_date", order: "desc" }
                : this.props.smartChartReducer.propertyEntityParams?.sortParams || { sort_by: "created_date", order: "desc" },
            filterKey: this.props.isSkeletonView
                ? this.props.smartChartReducer.coreReportEntityParams?.filterKey || ""
                : this.props.smartChartReducer.propertyEntityParams?.filterKey || "",
            showAppliedFilters: false,
            isDateFilter: false
        };
    }

    componentDidMount = async () => {
        let currentUser = localStorage.getItem("userId") || "";
        let previousProperty = sessionStorage.getItem("selectedProperty") || null;
        if (previousProperty && !this.props?.isReportView) {
            this.viewSmartChartProperty(previousProperty);
            sessionStorage.removeItem("selectedProperty");
        }
        await this.props.getSmartChartMasterFilterDropDown("clients", "smart_report_list_filter", {
            user_id: currentUser,
            source: this.props?.isSkeletonView ? "corereport" : "reporttemplates"
        });
        let clientList = this.props.smartChartReducer.masterFilterList?.smart_report_list_filter?.clients || [];
        await this.props.getSmartChartMasterFilterDropDown("projects", "smart_report_list_filter", {
            client_id: this.props.savedParams?.client_ids?.length
                ? this.props.savedParams?.client_ids?.[0]
                : clientList.find(client => client.default == true)?.id,
            user_id: currentUser,
            source: this.props?.isSkeletonView ? "corereport" : "reporttemplates"
        });
        let projectList = this.props.smartChartReducer.masterFilterList?.smart_report_list_filter?.projects || [];
        if (clientList.length) {
            let defaultClient = resolveDefaultClientFromList(clientList);
            let defaultProject = projectList.find(project => project.default == true) || null;
            if (defaultClient?.id) {
                const clientValue = this.props.savedParams?.client_ids ? [...this.props.savedParams?.client_ids] : [defaultClient.id];
                await this.setState({
                    mFilters: {
                        client_ids: clientValue,
                        project_ids: clientValue?.length
                            ? this.props.savedParams?.project_ids
                                ? [...this.props.savedParams?.project_ids]
                                : defaultProject
                                  ? [defaultProject?.id]
                                  : []
                            : [],
                        exportby_user_ids: this.state?.mFilters?.exportby_user_ids
                    },
                    defaultFilterParams: {
                        client_ids: [defaultClient.id]
                    }
                });
            }
        }
        await this.refreshSmartChartPropertyList();
    };
    componentDidUpdate = async () => {
        if (this.props.currentSection === "corereports" && this.props?.setUpdateCoreReport) {
            this.props?.setUpdateState();
            await this.refreshSmartChartPropertyList();
        }
    };

    refreshSmartChartPropertyList = async () => {
        let currentUser = localStorage.getItem("userId") || "";
        const { isSkeletonView = false } = this.props;
        this.setState({ isLoading: true });
        const { params, paginationParams, tableData, mFilters, sortParams, filterKey } = this.state;
        let smartChartPropertyList = [];
        let totalCount = 0;
        const { filterKeys, limit, offset, search, template_filter, date_filter } = params;
        const { sort_by, order } = sortParams;
        // let ordering = [];
        // ordering = Object.entries(order || [])
        //     .map(([key, value]) => (value === "asc" ? key : `-${key}`))
        //     .map(item => item.replace("setting_name", "setting_id__name"))
        //     .join(",");
        let templateParams = {
            ...filterKeys,
            limit,
            offset,
            search_query: search,
            sort_by,
            order,
            date_filter
            // ordering,
            // per_page_count: limit,
            // page_number: offset + 1
        };
        // if (mFilters?.project_ids?.length) {
        //     templateParams.project_id = [...mFilters.project_ids];
        // }
        if (mFilters?.client_ids?.length) {
            templateParams.client_id = mFilters.client_ids[0];
        }
        if (mFilters?.project_ids?.length) {
            templateParams.project_id = mFilters?.project_ids;
        }
        // if (!mFilters?.project_ids?.length && !mFilters?.client_ids?.length) {
        //     templateParams.user_id = currentUser;
        // }
        if (filterKey) {
            templateParams.locked = filterKey;
        }
        if (isSkeletonView) {
            templateParams.property_type = "SKEL";
        }
        if (mFilters?.exportby_user_ids?.length) {
            templateParams.exportby_user_ids = mFilters?.exportby_user_ids;
        }
        if (this.props?.isReportView) {
            templateParams.parent_props_id = this.props.match?.params?.id;
        }
        templateParams.user_id = currentUser;
        await this.props.getSmartChartPropertyList(templateParams, isSkeletonView ? "core-report" : "");
        const { getSmartChartPropertiesListResponse } = this.props.smartChartReducer;
        smartChartPropertyList = getSmartChartPropertiesListResponse?.data || [];
        totalCount = getSmartChartPropertiesListResponse?.count || 0;
        // go to previous page if no data found in the current page
        if (smartChartPropertyList && !smartChartPropertyList.length && paginationParams.currentPage) {
            await this.setState({
                paginationParams: {
                    ...paginationParams,
                    currentPage: this.state.paginationParams.currentPage - 1
                },
                params: {
                    ...params,
                    offset: (paginationParams.currentPage - 1) * paginationParams.perPage
                }
            });
            return await this.refreshSmartChartPropertyList();
        }

        if (
            smartChartPropertyList &&
            !smartChartPropertyList.length &&
            getSmartChartPropertiesListResponse &&
            (getSmartChartPropertiesListResponse.error || getSmartChartPropertiesListResponse.detail)
        ) {
            this.showAlert(
                typeof getSmartChartPropertiesListResponse.detail === "string"
                    ? getSmartChartPropertiesListResponse.detail
                    : getSmartChartPropertiesListResponse.error ?? ""
            );
        }

        smartChartPropertyList.map(temp => {
            temp.created_at = moment(temp.created_date).format("MM-DD-YYYY h:mm A");
        });
        this.setState({
            tableData: {
                ...tableData,
                data: smartChartPropertyList
                // config: tableData.config
            },
            smartChartPropertyList,
            paginationParams: {
                ...paginationParams,
                totalCount: totalCount,
                totalPages: Math.ceil(totalCount / paginationParams.perPage)
            },
            isLoading: false
        });
        // this.updateEntityParams();
        return true;
    };

    showAlert = msg => showAlertUtil(msg);

    updateWildCardFilter = async newFilter => {
        const { params, paginationParams } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                filters: newFilter
            },
            paginationParams: {
                ...paginationParams,
                currentPage: 0
            }
        });
        // this.updateEntityParams();
        await this.refreshSmartChartPropertyList();
    };

    updateEntityParams = async () => {
        const { filterKey, sortParams, params, paginationParams } = this.state;
        await this.props.updateSmartReportTemplateEntityParams(
            {
                entityParams: {
                    filterKey,
                    sortParams,
                    params,
                    paginationParams,
                    exportby_user_ids: this.state?.mFilters?.exportby_user_ids || []
                }
            },
            this.props.isSkeletonView ? "core-report" : "report-template"
        );
    };

    resetAllFilters = async () => {
        const { defaultFilterParams } = this.state;
        await this.setState({
            mFilters: {
                ...defaultFilterParams
            },
            filterKey: "",
            sortParams: {
                sort_by: "created_date",
                order: "desc"
            },
            params: {
                limit: 100,
                offset: 0,
                search: "",
                filters: null,
                list: null,
                active: true,
                date_filter: {}
            },
            isDateFilter: false
        });
        this.updateEntityParams();
        await this.refreshSmartChartPropertyList();
        this.props.updateFiltersForMasterFilter({ ...defaultFilterParams });
    };
    resetAll = async () => {
        await this.setState({
            selectedRegion: null,
            paginationParams: {
                totalPages: 0,
                perPage: 100,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                ...this.state.params,
                limit: 100,
                offset: 0,
                search: "",
                project_id: null,
                filters: null,
                date_filter: {},
                order: null,
                list: null
            },
            tableData: {
                ...this.state.tableData,
                config: _.cloneDeep(smartChartPropertiesTableData.config)
            },
            wildCardFilterParams: {},
            filterParams: {},
            selectedRowId: null,
            filterKey: "",
            sortParams: {
                sort_by: "created_date",
                order: "desc"
            },
            isDateFilter: false
        });
        this.updateEntityParams();
        await this.refreshSmartChartPropertyList();
    };

    resetSort = async () => {
        await this.setState({
            params: {
                ...this.state.params,
                order: null
            }
        });
        // this.updateEntityParams();
        await this.refreshSmartChartPropertyList();
    };
    isColunmVisibleChanged = () => {
        let flag = false;
        const {
            tableData: { keys, config }
        } = this.state;
        keys.map(key => {
            if (!_.isEqual(config[key]?.isVisible, smartChartPropertiesTableData.config[key]?.isVisible)) {
                flag = true;
            }
        });
        return flag;
    };
    getListForCommonFilter = async params => {
        // await this.props.getListForCommonFilter(params);
        // return (
        //     (this.props.reportPropertyReducer.getListForCommonFilterResponse &&
        //         this.props.reportPropertyReducer.getListForCommonFilterResponse.list) ||
        //     []
        // );
    };

    updateCommonFilter = async commonFilters => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                list: commonFilters
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        // this.updateEntityParams();
        await this.refreshSmartChartPropertyList();
    };

    updateTableSortFilters = async searchKey => {
        if (this.state.params.order) {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: {
                        ...this.state.params.order,
                        [searchKey]: this.state.params.order[searchKey] === "desc" ? "asc" : "desc"
                    }
                }
            });
        } else {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: { [searchKey]: "asc" }
                }
            });
        }
        // this.updateEntityParams();
        await this.refreshSmartChartPropertyList();
    };

    handleHideColumn = async keyItem => {
        if (keyItem !== "selectAll" && keyItem !== "deselectAll") {
            await this.setState({
                tableData: {
                    ...this.state.tableData,
                    config: {
                        ...this.state.tableData.config,
                        [keyItem]: {
                            ...this.state.tableData.config[keyItem],
                            isVisible: !this.state.tableData.config[keyItem].isVisible
                        }
                    }
                }
            });
        } else {
            let tempConfig = this.state.tableData.config;
            this.state.tableData.keys.map(item => {
                if (keyItem === "selectAll") {
                    tempConfig[item].isVisible = true;
                } else {
                    tempConfig[item].isVisible = false;
                }
            });
            await this.setState({
                tableData: {
                    ...this.state.tableData,
                    config: tempConfig
                }
            });
        }
        // await this.updateEntityParams();
        return true;
    };

    updateSelectedRow = async rowId => {
        await this.setState({
            selectedRowId: rowId
        });
        // await this.updateEntityParams();
    };

    handlePerPageChange = async e => {
        const { paginationParams, params } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                perPage: e.target.value,
                currentPage: 0
            },
            params: {
                ...params,
                offset: 0,
                limit: e.target.value
            }
        });
        await this.refreshSmartChartPropertyList();
    };

    handlePageClick = async page => {
        const { paginationParams, params } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                currentPage: page.selected
            },
            params: {
                ...params,
                // offset: page.selected * paginationParams.perPage
                offset: page.selected
            }
        });
        await this.refreshSmartChartPropertyList();
    };

    toggleWildCardFilter = () => {
        const { showWildCardFilter } = this.state;
        this.setState({
            showWildCardFilter: !showWildCardFilter
        });
    };

    updateMfilterForSmartChartList = async params => {
        let currentUser = localStorage.getItem("userId") || "";
        let updateFilterParams = {};
        if (params.mfilterKey === "client_ids") {
            await this.props.getSmartChartMasterFilterDropDown("projects", "smart_report_list_filter", {
                client_id: params.filterValues?.[0],
                exportby_user_ids: [],
                user_id: currentUser,
                source:
                    (this.props?.currentSection ?? this.props.match.params.section ?? this.props.isSkeletonView) ? "corereport" : "reporttemplates"
            });
            updateFilterParams = {
                [params.mfilterKey]: params.filterValues,
                project_ids: [],
                exportby_user_ids: []
            };
        } else {
            updateFilterParams = { [params.mfilterKey]: params.filterValues };
        }
        await this.setState(
            {
                mFilters: {
                    ...this.state.mFilters,
                    ...updateFilterParams
                },
                tableData: {
                    ...this.state.tableData,
                    data: []
                }
            },
            () => {
                this.updateEntityParams();
                this.refreshSmartChartPropertyList();
            }
        );
        if (params.mfilterKey !== "exportby_user_ids") {
            this.props.updateFiltersForMasterFilter({ ...updateFilterParams });
        }
    };

    deleteReportTemplate = template => {
        this.setState({
            showConfirmModal: true,
            selectedReportTemplate: template
        });
    };

    renderConfirmationModal = () => {
        const { showConfirmModal, selectedReportTemplate } = this.state;
        if (!showConfirmModal) return null;
        const { isSkeletonView = false } = this.props;
        let alertMsg = "This action cannot be reverted, are you sure that you need to delete this item?";
        const countBadge = (
            <>
                <span className="badge-red-circled">{selectedReportTemplate.total_smart_export_count}</span>
                {selectedReportTemplate.total_smart_export_count > 1 ? "reports" : "report"}
            </>
        );
        if (selectedReportTemplate?.total_smart_export_count > 0) {
            if (isSkeletonView) {
                alertMsg = (
                    <>
                        <b>It was used to generate{countBadge}.</b>
                        <p className="sm-charts-template-del-confirm">
                            The{countBadge} already generated from this Core Report will NOT be deleted.
                            <br />
                            FYI, you can create new Core Reports from the Report Templates section.
                        </p>
                    </>
                );
            } else {
                alertMsg = (
                    <>
                        <span className="badge-red-circled">{selectedReportTemplate.total_smart_export_count}</span>{" "}
                        {`Report${selectedReportTemplate.total_smart_export_count > 1 ? "s" : ""} ${
                            selectedReportTemplate.total_smart_export_count > 1 ? "are" : "is"
                        } already connected to this Report Template.`}
                        <p className="sm-charts-template-del-confirm">
                            <b>Deleting a template will delete all the reports connected to this template !</b>
                        </p>{" "}
                        This action cannot be reverted, are you sure that you need to delete this item?`
                    </>
                );
            }
        }
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to delete this ${isSkeletonView ? "Core Report" : "Report Template"}?`}
                        message={alertMsg}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={this.deleteReportTemplateConfirm}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    deleteReportTemplateConfirm = async () => {
        const { selectedReportTemplate } = this.state;
        this.setState({
            isLoading: true,
            showConfirmModal: false
        });
        const { isSkeletonView = false } = this.props;
        await this.props.deleteSmartChartReportTemplate(
            { property_id: selectedReportTemplate.id, is_delete: true },
            isSkeletonView ? "core-report" : ""
        );
        if (
            this.props.smartChartReducer.deleteSmartChartReportTemplateResponse?.error ||
            this.props.smartChartReducer.deleteSmartChartReportTemplateResponse?.detail
        ) {
            this.showAlert(this.props.smartChartReducer.deleteSmartChartReportTemplateResponse?.detail || "Oops..! failed to delete");
        } else {
            this.showAlert("Deleted successfully");
            await this.refreshSmartChartPropertyList();
        }
        this.setState({
            showConfirmModal: false,
            selectedReportTemplate: null,
            isLoading: false
        });
    };

    lockOrUnlockReportTemplate = async template => {
        let userRole = localStorage.getItem("role");
        if (userRole !== "super_admin") {
            if (!template.password && template.is_locked) {
                this.showAlert("This template is locked by system admin. please contact admin to unlock it.");
            } else {
                this.setState({ showLockTemplateModal: true, selectedReportTemplate: template });
            }
        } else {
            this.setState({
                isLoading: true
            });
            this.lockUpdateConfirm(template);
        }
    };

    renderLockPasswordModal = () => {
        const { showLockTemplateModal, selectedReportTemplate, isLockLoading } = this.state;
        if (!showLockTemplateModal) return null;
        return (
            <Portal
                body={
                    <LockPasswordModal
                        onCancel={() => this.setState({ showLockTemplateModal: false })}
                        updateLockPassword={this.lockUpdateConfirm}
                        selectedReportTemplate={selectedReportTemplate}
                        isLockLoading={isLockLoading}
                    />
                }
                onCancel={() => this.setState({ showLockTemplateModal: false })}
            />
        );
    };

    lockUpdateConfirm = async templateParams => {
        let userRole = localStorage.getItem("role");
        let currentUser = localStorage.getItem("userId") || "";
        this.setState({ isLockLoading: true });

        let lockParams = {
            is_locked: !templateParams.is_locked,
            property_id: templateParams.id,
            user_id: currentUser
        };
        if (templateParams.password) {
            lockParams.password = templateParams.password;
        }
        await this.props.lockSmartChartTemplate(lockParams);
        if (this.props.smartChartReducer.lockSmartChartTemplateResponse.success === false && templateParams.is_locked && userRole !== "super_admin") {
            this.setState({ isLockLoading: false });
            this.showAlert("Wrong password !!!");
        } else {
            if (this.state.showViewPropertyModal) {
                this.props.getSmartChartPropertyById(templateParams.id);
            }
            this.setState({ showLockTemplateModal: false, isLockLoading: false });
            await this.refreshSmartChartPropertyList();
        }
    };

    viewSmartChartProperty = async (propertyId, fromExport = false) => {
        this.setState({ showViewPropertyModal: true, selectedProperty: propertyId });
    };

    viewSourceTemplate = async (propertyId, fromExport = false) => {
        await this.props.getSmartChartSourceTemplete(propertyId);
        this.setState({ showTemplateModal: true, parentTemplate: propertyId });
    };

    renderSmartChartViewPropertyModal = () => {
        const { showViewPropertyModal, selectedProperty, isLockLoading } = this.state;
        const { handleEditSmartChartProperty, showSmartChartDataEditModal, viewReports } = this.props;
        let smartChartPropertyByIdData;
        if (!showViewPropertyModal) return null;
        smartChartPropertyByIdData = this.props.smartChartReducer.getSmartChartPropertyByIdResponse;
        const {
            location: { pathname }
        } = this.props;
        return (
            <Portal
                body={
                    <ViewPropertyModal
                        getSmartChartPropertyById={this.props.getSmartChartPropertyById}
                        smartChartPropertyByIdData={smartChartPropertyByIdData}
                        currentPropertyId={selectedProperty}
                        onCancel={() => this.setState({ showViewPropertyModal: false, selectedProperty: null })}
                        handleEditSmartChartProperty={handleEditSmartChartProperty}
                        currentTab={"reporttemplates"}
                        showSmartChartDataEditModal={showSmartChartDataEditModal}
                        viewReports={viewReports}
                        lockOrUnlockReportTemplate={this.lockOrUnlockReportTemplate}
                        isLockLoading={isLockLoading}
                        createReportFromSkeleton={this.createReportFromSkeleton}
                        viewSmartChartProperty={this.viewSourceTemplate}
                        tableConfig={this.state?.RecommendationTableData?.config}
                        isFavoriteView={pathname?.toLowerCase() === "/dashboard"}
                    />
                }
                onCancel={() => this.setState({ showViewPropertyModal: false, selectedProperty: null })}
            />
        );
    };
    renderSourceTemplateModal = () => {
        const { showTemplateModal, parentTemplate } = this.state;
        let smartChartPropertyByIdData;
        if (showTemplateModal) {
            smartChartPropertyByIdData = this.props.smartChartReducer.getSourceTemplate;
        } else {
            return null;
        }
        return (
            <Portal
                body={
                    <SourceTemplateModal
                        getSmartChartSourceTemplete={this.props.getSmartChartSourceTemplete}
                        smartChartPropertyByIdData={smartChartPropertyByIdData}
                        currentPropertyId={parentTemplate}
                        onCancel={() => this.setState({ showTemplateModal: false, selectedPropertys: null })}
                        refreshSmartChartPropertyList={this.refreshSmartChartPropertyList}
                        viewSmartChartProperty={this.viewSmartChartPropertys}
                        openFilterModal={item => this.setState({ showAppliedFilters: item })}
                    />
                }
                onCancel={() => this.setState({ showTemplateModal: false, selectedPropertys: null })}
            />
        );
    };

    handleSortData = async (key, value) => {
        await this.setState({
            sortParams: {
                ...this.state.sortParams,
                [key]: value
            }
        });
        await this.updateEntityParams();
        this.refreshSmartChartPropertyList();
    };

    handleSelectViewType = async filter => {
        await this.setState({ filterKey: filter });
        await this.updateEntityParams();
        this.refreshSmartChartPropertyList();
    };

    handleGlobalSearch = async search => {
        const { params } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                search
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        this.updateEntityParams();
        await this.refreshSmartChartPropertyList();
    };
    handleDateFilterChange = async filter => {
        const { params } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                date_filter: { ...filter }
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        this.updateEntityParams();
        await this.refreshSmartChartPropertyList();
    };
    createReportFromSkeleton = skeletonData => {
        addToBreadCrumpData({
            key: "add",
            name: "Create New Smart Chart Report Template",
            path: `/smartcharts/new?is_skeleton=${true}`
        });
        this.props.history.push(`/smartcharts/new?is_skeleton=${true}`, {
            property: skeletonData
        });
    };
    renderAppliedFilterModal = () => {
        if (!this.state.showAppliedFilters) return null;

        return (
            <Portal
                body={
                    <AppliedFilters
                        myFilters={
                            JSON.parse(this.props.smartChartReducer.getSourceTemplate?.data?.properties_text)?.project?.band1?.type[
                                this.state.showAppliedFilters
                            ]
                        }
                        tableConfig={this.state.RecommendationTableData?.config}
                        onCancel={() => this.setState({ showAppliedFilters: false })}
                    />
                }
                onCancel={() => this.setState({ showAppliedFilters: false })}
            />
        );
    };

    render() {
        const {
            getSmartChartMasterFilterDropDown,
            // viewSmartChartProperty,
            handleEditSmartChartProperty,
            handleExportSmartReport,
            showSmartChartDataEditModal,
            isSkeletonView = false,
            toggleCreateReportFromCoreReportModal,
            isModalView
        } = this.props;
        const { showWildCardFilter, paginationParams, tableData, selectedRowId, mFilters, sortParams, filterKey, isDateFilter, params } = this.state;
        let masterFilterList = this.props.smartChartReducer.masterFilterList;
        return (
            <LoadingOverlay active={this.state.isLoading} spinner={<Loader />} fadeSpeed={10}>
                <>
                    <PropertiesMain
                        getSmartChartPropertyById={this.props.getSmartChartPropertyById}
                        showWildCardFilter={showWildCardFilter}
                        paginationParams={paginationParams}
                        tableData={tableData}
                        handleGlobalSearch={this.handleGlobalSearch}
                        globalSearchKey={this.state.params?.search}
                        updateSelectedRow={this.updateSelectedRow}
                        selectedRowId={selectedRowId}
                        isColunmVisibleChanged={this.isColunmVisibleChanged}
                        toggleWildCardFilter={this.toggleWildCardFilter}
                        handlePerPageChange={this.handlePerPageChange}
                        handlePageClick={this.handlePageClick}
                        updateWildCardFilter={this.updateWildCardFilter}
                        wildCardFilter={this.state.params.filters}
                        handleHideColumn={this.handleHideColumn}
                        updateCommonFilter={this.updateCommonFilter}
                        commonFilter={this.state.params.list}
                        resetAllFilters={this.resetAllFilters}
                        resetAll={this.resetAll}
                        updateTableSortFilters={this.updateTableSortFilters}
                        resetSort={this.resetSort}
                        tableParams={this.state.params}
                        // showRestoreModal={this.showRestoreModal}
                        hasExport={
                            isSkeletonView
                                ? checkPermission("forms", permissions.CORE_REPORT, "export")
                                : checkPermission("forms", permissions.SMART_CHARTS, "export")
                        }
                        showAddButton={checkPermission("forms", permissions.SMART_CHARTS, "create") && !isSkeletonView}
                        hasEdit={
                            isSkeletonView
                                ? checkPermission("forms", permissions.CORE_REPORT, "edit")
                                : checkPermission("forms", permissions.SMART_CHARTS, "edit")
                        }
                        hasDelete={
                            isSkeletonView
                                ? checkPermission("forms", permissions.CORE_REPORT, "delete")
                                : checkPermission("forms", permissions.SMART_CHARTS, "delete")
                        }
                        hasOwnDelete={
                            isSkeletonView
                                ? checkPermission("forms", permissions.CORE_REPORT, "delete")
                                : checkPermission("forms", permissions.SMART_CHART_OWN_REPORT, "delete")
                        }
                        hasInfoPage={false}
                        entity={"exported_smart_charts"}
                        refreshTableData={this.refreshSmartChartPropertyList}
                        regenerateSmartChart={this.regenerateSmartChart}
                        getSmartChartMasterFilterDropDown={getSmartChartMasterFilterDropDown}
                        masterFilterList={masterFilterList}
                        mFilters={mFilters}
                        updateMfilterForSmartChartList={this.updateMfilterForSmartChartList}
                        hasActionColumn={false}
                        viewSmartChartProperty={this.viewSmartChartProperty}
                        handleEditSmartChartProperty={handleEditSmartChartProperty}
                        handleExportSmartReport={handleExportSmartReport}
                        showSmartChartDataEditModal={showSmartChartDataEditModal}
                        deleteReportTemplate={this.deleteReportTemplate}
                        lockOrUnlockReportTemplate={this.lockOrUnlockReportTemplate}
                        handleSortData={this.handleSortData}
                        handleSelectViewType={this.handleSelectViewType}
                        sortParams={sortParams}
                        viewType={filterKey}
                        isSkeletonView={isSkeletonView}
                        createReportFromSkeleton={this.createReportFromSkeleton}
                        toggleCreateReportFromCoreReportModal={toggleCreateReportFromCoreReportModal}
                        isModalView={isModalView}
                        onDateFilterClick={this?.onDateFilterClick}
                        handleDateFilterChange={this.handleDateFilterChange}
                        date_filter={params?.date_filter}
                        isDateFilter={isDateFilter}
                    />
                    {this.renderConfirmationModal()}
                    {this.renderLockPasswordModal()}
                    {this.renderSmartChartViewPropertyModal()}
                    {this.renderSourceTemplateModal()}
                    {this.renderAppliedFilterModal()}
                </>
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = state => {
    const { smartChartReducer, recommendationsReducer } = state;
    return { smartChartReducer, recommendationsReducer };
};

export default withRouter(
    connect(mapStateToProps, {
        ...actions
    })(Index)
);
